// import { Component, OnInit, ViewChild } from '@angular/core';
// import { CoreService } from '../../../services/core.service';
// import { ActivatedRoute, Router } from '@angular/router';
// import { CommonModule } from '@angular/common';
// import { MatTableModule, MatTableDataSource } from '@angular/material/table';
// import { MatIconModule } from '@angular/material/icon';
// import { MatTooltip } from '@angular/material/tooltip';
// import { MatButtonModule } from '@angular/material/button';
// import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
// import { MatSort, MatSortModule } from '@angular/material/sort';
// import { MatTooltipModule } from '@angular/material/tooltip';

// type Post = {
//   id: number;
//   rss_title: string;
//   domain_name?: string;
//   image_url: string;
//   post_status?: string;
//   enable_repeat?: number;
//   parent_post_id?: number;
//   tag?: string;
//   social_platform_title?: string;
//   scheduled_for?: string | Date;
//   rss_description?: string;
// };

// type Alert = {
//   id: number;
//   contentsite_id: number;
//   alert_text: string;
//   alert_type: string;
//   active: number;
//   platform: string;
//   format: string;
//   rss_img_url: string;
//   rss_title: string;
//   created_at: string | Date;
//   Domain: string;
//   posting_queue_id: number;
// };

// @Component({
//   selector: 'app-social-ai-list-of-repeat-posts-table',
//   standalone: true,
//   imports: [CommonModule,
//     MatTableModule,
//     MatPaginatorModule,
//     MatSortModule,
//     MatIconModule,
//     MatTooltip,
//     MatButtonModule,
//     MatTooltipModule
//   ],
//   templateUrl: './social-ai-list-of-repeat-posts-table.component.html',
//   styleUrl: './social-ai-list-of-repeat-posts-table.component.scss'
// })
// export class SocialAiListOfRepeatPostsTableComponent implements OnInit {


//   displayedColumns: string[] = [
//     // 'id',
//     'domain_name',
//     'category',
//     'article_url',
//     'rss_description',
//     'rss_title',
//     'social_platform_title',
//     'tag',
//     'week_day',
//     'scheduled_for',
//     'post_status',
//     'source'
//   ];

//   weekDays: string[] = [
//     'Monday',
//     'Tuesday',
//     'Wednesday',
//     'Thursday',
//     'Friday',
//     'Saturday',
//     'Sunday'
//   ];

//   maxSidebarCards = 3;
//   posts: Post[] = [];
//   alerts: Alert[] = [];
//   naPlaceholder = './assets/images/na.png';
//   private readonly LATEST_POSTS_KEY = 'latestPosts';
//   private readonly LATEST_ALERTS_KEY = 'latestAlerts';

//   totalItems = 0;
//   pageSize = 12;
//   dataSource = new MatTableDataSource<any>([]);
//   companyID: number = 0;

//   @ViewChild(MatPaginator) paginator!: MatPaginator;
//   @ViewChild(MatSort) sort!: MatSort;

//   constructor(private coreService: CoreService, private route: ActivatedRoute, private router: Router) { }


//   ngOnInit(): void {
//     this.route.queryParams.subscribe(params => {
//       const page = params['page'] ? Number(params['page']) : 1;
//       this.loadData(page);
//     });
//     this.loadSidebarPosts();
//     this.loadAlertsFromStorage();
//   }

//   loadData(page: number) {
//     this.companyID = this.coreService.user?.companyID || 0;

//     this.coreService
//       .getData(`/repeats/index/${this.companyID}?page=${page}`)
//       .subscribe((res: any) => {
//         this.dataSource.data = res.data || [];
//         this.totalItems = res.total;
//         this.pageSize = res.per_page;

//         if (this.paginator) {
//           this.paginator.pageIndex = res.current_page - 1;
//           this.paginator.length = res.total;
//           this.paginator.pageSize = res.per_page;
//         }
//       });
//   }


//   onPageChange(event: any) {
//     const newPage = event.pageIndex + 1;
//     this.loadData(newPage);
//   }

//   postStatusForm(value: string): string {
//     if (!value) return '';
//     return value.replace(/([A-Z])/g, ' $1').trim();
//   }

//   //Sidebar helpers
//   private loadSidebarPosts(): void {
//     if (typeof window === 'undefined') {
//       this.posts = [];
//       return;
//     }

//     const raw = localStorage.getItem(this.LATEST_POSTS_KEY);

//     if (!raw) {
//       this.posts = [];
//       return;
//     }

//     try {
//       const parsed = JSON.parse(raw) as Post[] | null;

//       if (Array.isArray(parsed)) {
//         this.posts = parsed.slice(0, this.maxSidebarCards);
//       } else {
//         this.posts = [];
//       }
//     } catch (e) {
//       console.error('Failed to parse latest posts from localStorage', e);
//       this.posts = [];
//     }
//   }

//   private loadAlertsFromStorage(): void {
//     if (typeof window === 'undefined') return;

//     const raw = localStorage.getItem(this.LATEST_ALERTS_KEY);
//     if (!raw) return;

//     try {
//       const parsed = JSON.parse(raw);
//       if (Array.isArray(parsed)) {
//         this.alerts = parsed.slice(0, this.maxSidebarCards);
//       }
//     } catch (e) {
//       console.error('Failed to parse alerts from storage', e);
//     }
//   }

//   viewAlert(alert: Alert): void {
//     const targetId = alert.posting_queue_id;
//     this.router.navigate(['/preview-post', alert.format, targetId]);
//   }

//   viewRow(row: Post) {
//     const targetId =
//       row.enable_repeat === -1 ? row.parent_post_id ?? row.id : row.id;
//     this.router.navigate(['/preview-post', row.tag, targetId]);
//   }

//   trackById = (_: number, item: Post) => item.id;

//   trackByAlertId = (_: number, item: Alert) => item.id;

//   onMainImgError(ev: Event): void {
//     const img = ev.target as HTMLImageElement;
//     if (!img || img.src.endsWith(this.naPlaceholder)) return;
//     img.src = this.naPlaceholder;
//   }

//   platformTextClass(plat?: string) {
//     const t = (plat || "").toLowerCase().trim();
//     switch (t) {
//       case "instagram":
//         return "text-fuchsia-600";
//       case "facebook":
//         return "text-blue-600";
//       case "x":
//         return "text-neutral-700";
//       case "youtube":
//         return "text-red-600";
//       default:
//         return "text-gray-700";
//     }
import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';

import { CoreService } from '../../../services/core.service';

import {
  LatestPost,
  LatestPostsComponent,
} from '../../sections/latest-posts/latest-posts.component';

import {
  LatestAlert,
  LatestAlertsComponent,
} from '../../sections/latest-alerts/latest-alerts.component';

@Component({
  selector: 'app-social-ai-list-of-repeat-posts-table',
  standalone: true,
  imports: [
    CommonModule,
    MatPaginatorModule,
    MatTooltipModule,
    LatestPostsComponent,
    LatestAlertsComponent,
  ],
  templateUrl: './social-ai-list-of-repeat-posts-table.component.html',
  styleUrl: './social-ai-list-of-repeat-posts-table.component.scss',
})
export class SocialAiListOfRepeatPostsTableComponent implements OnInit {
  weekDays: string[] = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];

  maxSidebarCards = 3;
  posts: LatestPost[] = [];
  alerts: LatestAlert[] = [];
  naPlaceholder = './assets/images/na.png';

  private readonly LATEST_POSTS_KEY = 'latestPosts';
  private readonly LATEST_ALERTS_KEY = 'latestAlerts';

  totalItems = 0;
  pageSize = 12;
  dataSource = new MatTableDataSource<any>([]);
  companyID: number = 0;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private coreService: CoreService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const page = params['page'] ? Number(params['page']) : 1;
      this.loadData(page);
    });

    this.loadSidebarPosts();
    this.loadAlertsFromStorage();
    this.listenForSidebarUpdates();
  }

  loadData(page: number): void {
    this.companyID = this.coreService.user?.companyID || 0;

    this.coreService
      .getData(`/repeats/index/${this.companyID}?page=${page}`)
      .subscribe((res: any) => {
        this.dataSource.data = res.data || [];
        this.totalItems = res.total;
        this.pageSize = res.per_page;

        if (this.paginator) {
          this.paginator.pageIndex = res.current_page - 1;
          this.paginator.length = res.total;
          this.paginator.pageSize = res.per_page;
        }
      });
  }

  onPageChange(event: any): void {
    const newPage = event.pageIndex + 1;
    this.loadData(newPage);
  }

  postStatusForm(value: string): string {
    if (!value) {
      return '';
    }

    return value.replace(/([A-Z])/g, ' $1').trim();
  }

  statusBadgeClass(status?: string): string {
    const s = (status || '').toLowerCase();

    if (s.includes('scheduled')) {
      return 'badge-blue';
    }

    if (s.includes('published') || s.includes('posted')) {
      return 'badge-green';
    }

    if (s.includes('pending')) {
      return 'badge-amber';
    }

    return 'badge-gray';
  }

  platformIconClass(platform?: string): string {
    const p = (platform || '').toLowerCase().trim();

    switch (p) {
      case 'instagram':
        return 'ti-brand-instagram';

      case 'facebook':
        return 'ti-brand-facebook';

      case 'x':
        return 'ti-brand-x';

      case 'youtube':
        return 'ti-brand-youtube';

      default:
        return 'ti-brand-social-media';
    }
  }

  platformTextClass(plat?: string): string {
    const t = (plat || '').toLowerCase().trim();

    switch (t) {
      case 'instagram':
        return 'text-fuchsia-600';

      case 'facebook':
        return 'text-blue-600';

      case 'x':
        return 'text-neutral-700';

      case 'youtube':
        return 'text-red-600';

      default:
        return 'text-gray-700';
    }
  }

  private loadSidebarPosts(): void {
    if (typeof window === 'undefined') {
      this.posts = [];
      return;
    }

    const raw = localStorage.getItem(this.LATEST_POSTS_KEY);

    if (!raw) {
      this.posts = [];
      return;
    }

    try {
      const parsed = JSON.parse(raw) as LatestPost[] | null;

      this.posts = Array.isArray(parsed)
        ? parsed.slice(0, this.maxSidebarCards)
        : [];
    } catch (error) {
      console.error('Failed to parse latest posts from localStorage', error);
      this.posts = [];
    }
  }

  private loadAlertsFromStorage(): void {
    if (typeof window === 'undefined') {
      this.alerts = [];
      return;
    }

    const raw = localStorage.getItem(this.LATEST_ALERTS_KEY);

    if (!raw) {
      this.alerts = [];
      return;
    }

    try {
      const parsed = JSON.parse(raw) as LatestAlert[] | null;

      this.alerts = Array.isArray(parsed)
        ? parsed.slice(0, this.maxSidebarCards)
        : [];
    } catch (error) {
      console.error('Failed to parse alerts from storage', error);
      this.alerts = [];
    }
  }

  private listenForSidebarUpdates(): void {
    this.coreService.latestPosts$.subscribe(posts => {
      if (posts && posts.length > 0) {
        this.posts = (posts as LatestPost[]).slice(0, this.maxSidebarCards);
      }
    });

    this.coreService.latestAlerts$.subscribe(alerts => {
      if (alerts && alerts.length > 0) {
        this.alerts = (alerts as LatestAlert[]).slice(0, this.maxSidebarCards);
      }
    });
  }

  /**
   * Main repeated-post table row click.
   */
  viewRow(row: any): void {
    const targetId =
      row.enable_repeat === -1 ? row.parent_post_id ?? row.id : row.id;

    this.router.navigate(['/preview-post', row.tag, targetId]);
  }

  /**
   * Latest posts sidebar click.
   */
  viewLatestPost(row: any): void {
    const targetId =
      row.enable_repeat === -1 ? row.parent_post_id ?? row.id : row.id;

    this.router.navigate(['/preview-post', row.tag, targetId]);
  }

  /**
   * Latest alerts sidebar click.
   */
  viewLatestAlert(alert: any): void {
    this.router.navigate([
      '/preview-post',
      alert.format,
      alert.posting_queue_id,
    ]);
  }

  trackById = (_: number, item: any): number => item.id;

  trackByAlertId = (_: number, item: any): number => item.id;

  onMainImgError(ev: Event): void {
    const img = ev.target as HTMLImageElement;

    if (!img || img.src.endsWith(this.naPlaceholder)) {
      return;
    }

    img.src = this.naPlaceholder;
  }
}